import { usePlayer } from "../context/PlayerContext";
import { Play, Pause, RotateCcw, RotateCw, X, Volume2 } from "lucide-react";
import { fmtTime } from "../lib/format";

const RATES = [0.8, 1, 1.25, 1.5, 2];

export default function GlobalAudioPlayer() {
  const { current, playing, progress, rate, toggle, seek, seekTo, changeRate, close } = usePlayer();
  if (!current) return null;
  const pct = progress.duration ? (progress.position / progress.duration) * 100 : 0;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 backdrop-blur-md bg-white/90 border-t border-slate-200 shadow-[0_-4px_16px_rgba(0,0,0,0.08)]" data-testid="global-audio-player">
      <div className="max-w-5xl mx-auto px-4 py-3">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-lg bg-[#0A192F] flex items-center justify-center shrink-0">
            <Volume2 className="h-5 w-5 text-amber-500" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-sm font-semibold text-[#0A192F] truncate font-heading">{current.title}</div>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-[11px] font-mono text-slate-500 w-10 text-right">{fmtTime(progress.position)}</span>
              <input
                type="range" min={0} max={progress.duration || 0} value={progress.position}
                onChange={(e) => seekTo(Number(e.target.value))}
                className="flex-1 h-1 accent-amber-600 cursor-pointer"
                data-testid="audio-seek"
                style={{ background: `linear-gradient(to right,#D97706 ${pct}%,#e2e8f0 ${pct}%)` }}
              />
              <span className="text-[11px] font-mono text-slate-500 w-10">{fmtTime(progress.duration)}</span>
            </div>
          </div>
          <div className="flex items-center gap-1 shrink-0">
            <button onClick={() => seek(-15)} className="p-2 text-slate-600 hover:text-[#0A192F]" data-testid="audio-back-15" title="Back 15s"><RotateCcw className="h-5 w-5" /></button>
            <button onClick={toggle} className="h-11 w-11 rounded-full bg-amber-600 hover:bg-amber-700 text-white flex items-center justify-center" data-testid="audio-play-pause-btn">
              {playing ? <Pause className="h-5 w-5" /> : <Play className="h-5 w-5 ml-0.5" />}
            </button>
            <button onClick={() => seek(15)} className="p-2 text-slate-600 hover:text-[#0A192F]" data-testid="audio-fwd-15" title="Forward 15s"><RotateCw className="h-5 w-5" /></button>
            <select value={rate} onChange={(e) => changeRate(Number(e.target.value))} className="text-xs font-mono border border-slate-200 rounded-md px-1 py-1 bg-white" data-testid="audio-speed-select">
              {RATES.map((r) => <option key={r} value={r}>{r}x</option>)}
            </select>
            <button onClick={close} className="p-2 text-slate-400 hover:text-slate-700" data-testid="audio-close-btn"><X className="h-4 w-4" /></button>
          </div>
        </div>
      </div>
    </div>
  );
}
